module.exports = __webpack_public_path__ + "static/media/img-1.ff08d703.svg";